module.exports = __webpack_public_path__ + "img/patients_white.fce9d5f1.svg";